/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import type {
  ReactElement,
} from 'react';
import styled from 'styled-components';

import type {
  ControlProps,
} from 'react-select';

import type {
  OptionTypeBase,
} from '../types';

const Wrapper = styled.div(({
  theme: {
    colors,
    input,
  },
}) => ({
  position: 'relative',
  boxSizing: 'border-box',
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  outline: 0,
  transition: 'all 100ms',
  minHeight: input.HEIGHT_SMALL,

  '&::after': {
    content: '""',
    position: 'absolute',
    left: 15,
    right: 15,
    height: 1,
    bottom: 0,
    backgroundColor: colors.NEUTRAL_INACTIVE,
  },
}));

export function Control<
OptionType extends OptionTypeBase,
IsMulti extends boolean,
>(
  props: ControlProps<OptionType, IsMulti>,
): ReactElement {
  const {
    children,
    innerRef,
    innerProps,
    className,
  } = props;

  return (
    <Wrapper
      ref={innerRef as any}
      className={className}
      {...innerProps}
    >
      {children}
    </Wrapper>
  );
}
